import React from 'react';
import { useGame } from '../context/GameContext';
import { Heart, TrendingUp } from 'lucide-react';

export default function Rest() {
  const { doRestHeal, openRestUpgrade, run } = useGame();
  const healAmount = Math.floor(run.player.maxHp * 0.3);
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-6">
      <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">CAMPFIRE</div>
      <h1 className="font-display text-5xl sm:text-6xl font-black uppercase text-[color:var(--neon)] mt-2">TAKE A BREAK</h1>
      <div className="text-[color:var(--text-dim)] mt-4 max-w-xl text-center">Nobody's watching. Recharge or grind, up to you.</div>
      <div className="mt-10 grid grid-cols-2 gap-6 max-w-3xl w-full">
        <button className="brutal-btn text-xl py-6 flex flex-col items-center gap-2"
          onClick={doRestHeal}
          data-testid="rest-heal-button">
          <Heart size={28} />
          HEAL +{healAmount} HP
        </button>
        <button className="brutal-btn-pink brutal-btn text-xl py-6 flex flex-col items-center gap-2"
          onClick={openRestUpgrade}
          data-testid="rest-upgrade-button">
          <TrendingUp size={28} />
          UPGRADE A CARD
        </button>
      </div>
    </div>
  );
}
